// Анимация прокрутки
//window.AOS = require('aos/dist/aos');
window.Toastr = require('toastr');
window.Select2 = require('select2');
require('select2/dist/js/i18n/ru');

// Красивый селект
//require('jquery-nice-select/js/jquery.nice-select');
